import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setHeaderDetailsOpen, setHeaderDetailsOpenFalse } from '../modules/header_details_open';

class Offer extends Component {
  constructor(props) {
    super(props);
    this.toggleDetails = this.toggleDetails.bind(this);
  }

  toggleDetails(){
    if (this.props.headerDetailsOpen === true) {
      this.props.dispatch( setHeaderDetailsOpenFalse() );
    } else {
      this.props.dispatch( setHeaderDetailsOpen() );
    }
  }

  render() {
    let books = this.props.store_tla === "DVD" ? "DVDs" : "books";
    let promo = this.props.promos[0];
    let offer       = "FREE SHIPPING ON 3+" + (this.props.store_tla === "DVD" ? " DVDs!": " BOOKS!");
    let tipButton   = this.props.store_bundle_pricing ? <div /> : <button className="edit-link tipButton" onClick={this.toggleDetails.bind(this)}>Details</button>;

    let tipDetails = this.props.headerDetailsOpen ? (
        <div className="modal-window header-info">
          <div className="modal-close" onClick={this.toggleDetails.bind(this)}>&times;</div>
          <p> Free shipping is only eligible on orders of 3 or more {books} with a subtotal of $35+. </p>
          <p> Pre-orders are not eligible for free shipping. </p>
        </div>
    ): (<div />);

    // let hasGiftShop = this.props.genres.find(e=> { return e.is_gift_shop === true }); // for gift shop promos

    if (this.props.isLoggedIn && promo && promo) {
      offer = promo.blurb;
      tipButton = <button className="edit-link tipButton" onClick={this.toggleDetails.bind(this)}>Details</button>;
      tipDetails = this.props.headerDetailsOpen ? (
          <div className="modal-window header-info">
            <div className="modal-close" onClick={this.toggleDetails.bind(this)}>&times;</div>
            <p>{promo.description}</p>
          </div>
      ): (<div />);
    }

    return (
      <div className="header-offer">
        <h4 className="offer">{offer}</h4>
        {tipButton}
        {tipDetails}
      </div>
    );
  }
};


function mapStateToProps(state){
    return {
      'type': state.store.type,
      'isLoggedIn': state.isLoggedIn,
      'headerDetailsOpen': state.headerDetailsOpen,
      'promos': state.promos,
      'genres': state.genres,
      'store_tla': state.store.tla,
      'store_bundle_pricing': state.store.bundle_pricing
    };
}

export default connect(mapStateToProps)(Offer);


// WEBPACK FOOTER //
// ./src/components/Offer.jsx